import GCurrency from 'tennders-market/common/components/element/GCurrency'
import GHref from 'tennders-market/common/components/element/GHref'
import useTranslation from 'next-translate/useTranslation'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck } from '@fortawesome/free-solid-svg-icons'
import React from 'react'

const OfferSentMessage = ({ form, counter }) => {
  const { t } = useTranslation()
  return (
    <div style={counter ? { position: 'relative' } : {}} className="truck-finalize show">
      <FontAwesomeIcon icon={faCheck} fontSize={48} aria-hidden="true" className="mb-20" />
      <h4 className="bold">
        {t('offer:yourOfferIs')} :
        {' '}
        {' '}
        <GCurrency value={form?.bid} />
      </h4>

      <p>
        {t('offer:offerNotifSent')}
      </p>

      {!counter && (
        <p>
          {t('offer:trackOffer')}                                                            {' '}
          <GHref onClick={() => window.location.reload()} className="text-underline bold">{t('offer:transactionsSection')}     </GHref>
          {' '}
          {t('offer:underNegotiationStatus')}
        </p>
      )}
    </div>
  )
}
export default OfferSentMessage
